/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S1_TitleInputs */

const en_guide_large_json_files_s1_title = /** @type {(inputs: Guide_Large_Json_Files_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why Large JSON Files Are Challenging`)
};

const ko_guide_large_json_files_s1_title = /** @type {(inputs: Guide_Large_Json_Files_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대용량 JSON 파일이 어려운 이유`)
};

const ja_guide_large_json_files_s1_title = /** @type {(inputs: Guide_Large_Json_Files_S1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きなJSONファイルが難しい理由`)
};

/**
* | output |
* | --- |
* | "Why Large JSON Files Are Challenging" |
*
* @param {Guide_Large_Json_Files_S1_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s1_title = /** @type {((inputs?: Guide_Large_Json_Files_S1_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S1_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s1_title(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s1_title(inputs)
	return ja_guide_large_json_files_s1_title(inputs)
});